export function getStoredUserId() {
  const raw = localStorage.getItem("userId");
  if (!raw || raw === "null") {
    return null;
  }
  try {
    const parsed = JSON.parse(raw);
    return parsed == null ? null : String(parsed);
  } catch {
    return raw;
  }
}

export function getStoredOrganizationId() {
  const raw = localStorage.getItem("organizationId");
  if (!raw || raw === "null") {
    return null;
  }
  try {
    const parsed = JSON.parse(raw);
    return parsed == null ? null : String(parsed);
  } catch {
    return raw;
  }
}

export function setStoredOrganizationId(organizationId) {
  if (organizationId == null) {
    localStorage.removeItem("organizationId");
    return;
  }
  localStorage.setItem("organizationId", String(organizationId));
}

export function getAuthHeaders() {
  const token = localStorage.getItem("Token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}
